import { computed, type Ref } from 'vue';
import { useStorage } from '@vueuse/core';
import type { UserLoopSection } from '@/types';

type UserLoopSectionMap = Record<string, UserLoopSection>;

const USER_LOOP_STORAGE_KEY = 'user-loop-sections-v1';
const storedUserLoops = useStorage<UserLoopSectionMap>(USER_LOOP_STORAGE_KEY, {});

export function useUserLoopSectionStorage(musicalPieceId: Ref<string | null | undefined>) {
  const userLoopSection = computed<UserLoopSection | null>(() => {
    const id = musicalPieceId.value;
    if (!id) return null;
    return storedUserLoops.value[id] ?? null;
  });

  const saveUserLoopSection = (section: UserLoopSection) => {
    const id = musicalPieceId.value;
    if (!id) return;
    storedUserLoops.value = {
      ...storedUserLoops.value,
      [id]: {
        startMeasureIndex: section.startMeasureIndex,
        endMeasureIndex: section.endMeasureIndex,
      },
    };
  };

  const clearUserLoopSection = () => {
    const id = musicalPieceId.value;
    if (!id || !storedUserLoops.value[id]) return;
    const { [id]: _removed, ...rest } = storedUserLoops.value;
    storedUserLoops.value = rest;
  };

  return {
    userLoopSection,
    saveUserLoopSection,
    clearUserLoopSection,
  };
}
